const PageHeader = ({ tag, title, subtitle }) => (
  <>
    <style>{`
      .page-header {
        background: linear-gradient(135deg, var(--deep) 0%, #1a2e45 100%);
        /* pt = navbar height (80px) + extra breathing room */
        padding: 160px 60px 80px;
        text-align: center;
      }
      .page-header h1 {
        color: white;
        font-size: clamp(32px, 5vw, 56px);
        margin-bottom: 12px;
      }
      .page-header p {
        color: rgba(255,255,255,0.65);
        font-size: 16px;
        max-width: 500px;
        margin: 0 auto;
      }
      @media(max-width:768px) {
        .page-header { padding: 140px 20px 50px; }
      }
    `}</style>
    <div className="page-header">
      <span className="section-tag">✦ {tag}</span>
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </div>
  </>
);

export default PageHeader;
